<template>
  <app-dialog v-model="dialogIsOpen" :title="currentTitle" maxWidth="550" @click:outside="close">
    <div v-if="currentStep === 0" class="w-100">
      <v-form @submit.prevent="verifyCurrentPassword" class="d-flex justify-center flex-column mx-auto w-80" ref="currentPasswordForm">
        <v-card-text class="d-flex flex-column align-center w-100">
          <v-text-field dense v-model="currentPassword" :label="$t('label.currentPassword')" type="password" class="stretch-append text-field-styling w-100" outlined rounded />
        </v-card-text>

        <v-card-actions class="d-flex flex-column align-stretch px-4 pt-0 mt-10">
          <app-button class="green-gradient-right override-disabled-styles mb-5" type="submit" :disabled="!currentPassword" :loading="loading" invert gradient :label="$t('button.next')" />
          <v-btn class="align-self-center primary--text" icon fab @click="dialogIsOpen = false"><LeftArrow /></v-btn>
        </v-card-actions>
      </v-form>
    </div>
    <div v-if="currentStep === 1">
      <v-form v-model="formIsValid" @submit.prevent="submitChangePassword" class="d-flex justify-center flex-column" ref="createPasswordForm">
        <v-card-text class="d-flex flex-column align-center pb-0">
          <PasswordField v-model="newPassword" hide-details :rules="[...$rules.passwordRules]" />
          <ul class="w-100 my-3">
            <li :class="['ml-5', minLengthMarker]">{{ $t('message.minPasswordLength') }}</li>
            <li :class="['ml-5', minNumericMarker]">{{ $t('message.minPasswordNumeric') }}</li>
          </ul>
        </v-card-text>

        <v-card-actions class="d-flex flex-column align-stretch px-4 pt-0 mt-10">
          <app-button class="green-gradient-right override-disabled-styles mb-5" type="submit" :disabled="!formIsValid" :loading="loading" invert gradient :label="$t('label.set')" />
          <v-btn class="align-self-center primary--text" icon fab @click="onPrevStep"><LeftArrow /></v-btn>
        </v-card-actions>
      </v-form>
    </div>
  </app-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { localeHelper } from '@/utils'
import validationHelper from '@/utils/validation.helper'
import PasswordField from '@/components/fields/PasswordField'
import LeftArrow from '@/assets/icons/left-arrow-circle.svg'

export default {
  components: { PasswordField, LeftArrow },
  props: ['value'],
  data: () => ({
    loading: false,
    currentStep: 0,
    formSteps: [{ title: localeHelper.getMessage('label.currentPassword') }, { title: localeHelper.getMessage('label.newPassword') }],
    currentPassword: '',
    newPassword: '',
    formIsValid: false
  }),
  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.currentStep = 0
        this.$emit('input', val)
      }
    },
    currentTitle() {
      return this.formSteps[this.currentStep].title
    },
    minLengthMarker() {
      return this.newPassword.length >= 6 ? 'validation-item-marked' : 'validation-item-unmarked'
    },
    minNumericMarker() {
      // must be strictly true, because if the validation fails, will return the error string which is still truthy
      return validationHelper.minOneNumeric(this.newPassword) === true ? 'validation-item-marked' : 'validation-item-unmarked'
    }
  },
  methods: {
    ...mapActions('auth', ['checkCurrentPassword', 'changePassword']),
    close() {
      console.log('ON CLOSE')
      this.currentPassword = ''
      this.newPassword = ''
      this.dialogIsOpen = false
    },

    onNextStep() {
      if (this.currentStep === this.formSteps.length - 1) {
        this.close()
        return
      }
      this.currentStep++
    },

    onPrevStep() {
      if (this.currentStep > 0) this.currentStep--
    },
    async verifyCurrentPassword() {
      this.loading = true
      await this.checkCurrentPassword({
        current_password: this.currentPassword
      })
        .then(() => {
          this.onNextStep()
        })
        .catch((err) => {
          this.$toast.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async submitChangePassword() {
      await this.changePassword({
        current_password: this.currentPassword,
        password: this.newPassword,
        password_confirmation: this.newPassword
      })
        .then(() => {
          this.$toast.success(localeHelper.getMessage('message.changePasswordSuccess'))
          this.close()
        })
        .catch((err) => {
          this.$toast.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
